//Talen Info,
export const GET_LIST_PARTNERS_REQUEST = 'instalent/GET_LIST_PARTNERS_REQUEST';
export const GET_LIST_PARTNERS_SUCCESS = 'instalent/GET_LIST_PARTNERS_SUCCESS';
export const GET_LIST_PARTNERS_FAIL = 'instalent/GET_LIST_PARTNERS_FAIL';

